import React, { useState, useCallback, useEffect } from 'react';
import { Datagrid, EditButton, TextField, useDataProvider, FunctionField } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { handleAPIErrors } from '../../utils';
import { List } from '../../components/List';
import { CustomPagination } from '../../components/CustomPagination';
import { LinkToRelatedDomains, NoWebsitesPage, WebsitesListHeader } from './components';
import MainListWrapper from '../../components/MainListWrapper';
import { externalRedirect } from '../../utils';

const tableStyles = {
  headerCell: {
    padding: '28px 39px',
  },
  rowCell: {
    padding: '28px 39px',
    width: '580px',
  },
};

const websiteNameStyle = {
  button: {
    fontSize: '20px',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '0 !important',
    textTransform: 'lowercase',
    minWidth: '0',
    '& span': {
      padding: '0 !important',
    },
    '& svg': {
      display: 'none'
    },
  }
};

const EditOnWebsiteName = withStyles(websiteNameStyle)(({classes, record, basePath}) => (
  <EditButton
    basePath={basePath}
    record={record}
    label={record.name}
    classes={classes}>
  </EditButton>
));

const CustomWebsitesList = (props) => {
  externalRedirect('consent-solutions');
  return (<></>);

  const [loading, setLoading] = useState(true);

  const dataProvider = useDataProvider();
  const { classes, ...rest } = props;

  const getWebsites = useCallback(() => {
    return dataProvider
      .getList('websites', {
        pagination: { page: 1 },
        sort: { field: 'id', order: 'DESC' },
      })
      .then((websitesResponse) => {
        return websitesResponse;
      })
      .catch((error) => {
        handleAPIErrors(error, props.history);
        console.error(error);
      });
  }, [dataProvider, props.history]);

  const initializeList = useCallback(() => {
    getWebsites().then((websitesResponse = {}) => {
      setLoading(false);
    });
  }, [getWebsites]);

  useEffect(() => initializeList(), [initializeList]);

  if (loading === true) {
    return null;
  }

  return (
    <MainListWrapper>
      <List
        {...rest}
        actions={false}
        filters={<WebsitesListHeader />}
        bulkActionButtons={false}
        sort={{field: 'id', order: 'DESC'}}
        pagination={<CustomPagination/>}
        empty={<NoWebsitesPage/>}
      >
        <CustomDataGrid
          classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}
          {...props}
        />
      </List>
    </MainListWrapper>
  );
};

class CustomDataGrid extends React.Component {
  render() {
    const {permissions, hasShow, hasEdit, hasList, ...rest} = this.props;

    return (
      <Datagrid {...rest}>
        {permissions === 'ROLE_ADMIN' &&
          <FunctionField label="Account ID" render={record => `${record.account.replace('/accounts/', '')}`} />}
        <EditOnWebsiteName label="Consent Solution Name"/>
        <LinkToRelatedDomains sortable={false} label="Domains in Consent Solution"/>
        {permissions === 'ROLE_ADMIN' && <TextField source="status" />}
      </Datagrid>
    );
  }
}

export const WebsitesList = withStyles(tableStyles)(CustomWebsitesList);
